module.exports = __webpack_public_path__ + "img/kommune-1617.8b9652f6.svg";